export default __webpack_public_path__ + "static/media/saved-flag.7b0ecf34.svg";